import * as React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import * as Comp from "../../components";
import { Paths } from "../../constants";
import { AppState } from "../../store";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
});

type OwnProps = RouteComponentProps<{}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
};

interface OwnState {
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class HomeComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {
    public render() {
        return <Comp.Page.PublicPage additionalClasses="full">
            <Comp.Layout.ContentPrimary>
                <ul className="featured-pages">
                    <li>
                        <h3><Link to={Paths.User.Abstracts.UserAbstracts}>Abstract Submission System</Link></h3>
                        <p><Link to={Paths.User.Abstracts.UserAbstracts}><img alt="" src="/content/images/abstracts.png?456" /></Link></p>
                    </li>
                    <li>
                        <h3><Link to={Paths.CareerCenter.Landing}>Retina Career Center</Link></h3>
                        <p><Link to={Paths.CareerCenter.Landing}><img alt="" src="/content/images/rcc.png" /></Link></p>
                    </li>
                </ul>
            </Comp.Layout.ContentPrimary>
            <Comp.Layout.ContentSecondary />
            <div className="clear" />
        </Comp.Page.PublicPage>;
    }
}

export const Home: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(HomeComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/page/Home.tsx